stateProviders.push({

    name: "printApp",
    url: "/print/:applicationID",
    templateUrl: "fast/submodules/schoolside/applications/submodules/printableSummary/partials/printableSummary.html?v=" + versionNo,
    controller: "PrintableSummaryController"

});

stateProviders.push({
	name: "printLetter",
	url: "/print/:applicationID/:letterID",
	templateUrl: "fast/submodules/schoolside/applications/submodules/printableSummary/partials/printableLetter.html?v=" + versionNo,
	controller: "PrintableLetterController",
	resolve: {
		app: function(ApplicationService) {
			return ApplicationService.getAwardData();
		}
	}
});

stateProviders.push({
    name: 'printApps',
    url: '/printBin/:bin',
    templateUrl: 'fast/submodules/schoolside/applications/submodules/printableSummary/partials/printApplications.html?v=' + versionNo,
    controller: "PrintApplicationsController",
    resolve :
    {
        bins: function(BinFactory, BinService, authServiceFactory, $stateParams)
        {
            authServiceFactory.check();
            BinService.setBin($stateParams.bin);
            return BinFactory.retrieveData();
        },
        schoolSubcategories: function(SchoolSubcategoriesModelService, authServiceFactory)
        {
            return SchoolSubcategoriesModelService.get(authServiceFactory.getAuth().schoolID);
        },
        account: function(AccountModelService, authServiceFactory)
        {
            return AccountModelService.get(authServiceFactory.getAuth().schoolID);
        },
        thresh: function(SchoolModelService, authServiceFactory)
        {
            SchoolModelService.resolveData(authServiceFactory.getAuth().schoolID);
        },
        permissions: function(PermissionModelService, authServiceFactory)
        {
            PermissionModelService.resolveData(authServiceFactory.getAuth().schoolID);
        }

    }

});

stateProviders.push({
    name: 'printArchivedApps',
    url: '/printBin/archive/:bin/:year',
    templateUrl: 'fast/submodules/schoolside/applications/submodules/printableSummary/partials/printApplications.html?v=' + versionNo,
    controller: "PrintApplicationsController",
    resolve :
    {
        bins: function(BinFactory, BinService, BinSummaryService, authServiceFactory, $stateParams)
        {
            authServiceFactory.check();
            BinService.setBin($stateParams.bin);
            return BinFactory.retrieveData(true);
        },
        schoolSubcategories: function(SchoolSubcategoriesModelService, authServiceFactory)
        {
            return SchoolSubcategoriesModelService.get(authServiceFactory.getAuth().schoolID);
        },
        account: function(AccountModelService, authServiceFactory)
        {
            return AccountModelService.get(authServiceFactory.getAuth().schoolID);
        },
        thresh: function(SchoolModelService, authServiceFactory)
        {
            SchoolModelService.resolveData(authServiceFactory.getAuth().schoolID);
        },
        permissions: function(PermissionModelService, authServiceFactory)
        {
            PermissionModelService.resolveData(authServiceFactory.getAuth().schoolID);
        }

    }

});